import { useState, useEffect, useRef } from 'react';
import './Gallery.css';
import { SectionHeader } from './Services';
import gorsel1 from '../images/gorsel1.jpeg';
import gorsel2 from '../images/gorsel2.jpeg';
import gorsel3 from '../images/gorsel3.jpeg';
import gorsel4 from '../images/gorsel4.jpeg';
import gorsel5 from '../images/gorsel5.jpeg';
import gorsel6 from '../images/gorsel6.jpeg';
import video1  from '../images/video1.mp4';

const ITEMS = [
  { type: 'image', src: gorsel1, label: 'Banyo Yenileme' },
  { type: 'image', src: gorsel2, label: 'Su Kaçağı Tespiti' },
  { type: 'image', src: gorsel3, label: 'Kameralı Boroskop' },
  { type: 'image', src: gorsel4, label: 'Tesisat Tamiri' },
  { type: 'image', src: gorsel5, label: 'Su Kaçağı Tespiti' },
  { type: 'image', src: gorsel6, label: 'Tıkanıklık Açma' },
  { type: 'video', src: video1,  label: 'Saha Çalışması' },
];

function Gallery() {
  const [selected, setSelected]   = useState(null);
  const [open, setOpen]           = useState(false);   // layout açık mı
  const [previewKey, setPreviewKey] = useState(0);     // preview yeniden render için
  const [previewVisible, setPreviewVisible] = useState(false); // fade-in
  const closeTimer = useRef(null);

  const handleSelect = (item) => {
    if (selected === item) {
      handleClose();
      return;
    }

    if (!open) {
      // İlk kez açılıyor
      setSelected(item);
      setOpen(true);
      setTimeout(() => setPreviewVisible(true), 50);
    } else {
      // Zaten açık, farklı öğe seçildi — preview'ı flash yap
      setPreviewVisible(false);
      setTimeout(() => {
        setSelected(item);
        setPreviewKey(k => k + 1);
        setTimeout(() => setPreviewVisible(true), 40);
      }, 200);
    }
  };

  const handleClose = () => {
    setPreviewVisible(false);
    setTimeout(() => {
      setOpen(false);
      setSelected(null);
    }, 350);
  };

  useEffect(() => {
    return () => clearTimeout(closeTimer.current);
  }, []);

  return (
    <section id="galeri" className="gallery">
      <div className="gallery__inner">
        <SectionHeader tag="Galeri" title="Çalışmalarımızdan" titleAccent="Kareler" center />

        <div className={`gallery__layout${open ? ' gallery__layout--open' : ''}`}>

          {/* SOL — grid / küçük liste */}
          <div className="gallery__grid">
            {ITEMS.map((item, i) => (
              <div
                key={i}
                style={{ '--i': i }}
                className={`gallery__card${selected === item ? ' gallery__card--active' : ''}`}
                onClick={() => handleSelect(item)}
              >
                {item.type === 'video'
                  ? <video src={item.src} className="gallery__img" muted />
                  : <img src={item.src} alt={item.label} className="gallery__img" />
                }
                <div className="gallery__overlay">
                  <div className="gallery__label-bar" />
                  <div className="gallery__label">{item.label}</div>
                </div>
                {item.type === 'video' && <span className="gallery__badge">▶ Video</span>}
                {selected === item && <div className="gallery__card-glow" />}
              </div>
            ))}
          </div>

          {/* SAĞ — büyük önizleme */}
          {open && (
            <div className={`gallery__preview${previewVisible ? ' gallery__preview--visible' : ''}`}>
              <button className="gallery__close" onClick={handleClose}>✕</button>

              <div className="gallery__preview-inner" key={previewKey}>
                {selected?.type === 'video' ? (
                  <video
                    src={selected.src}
                    className="gallery__preview-media"
                    autoPlay muted loop playsInline controls
                  />
                ) : (
                  <img
                    src={selected?.src}
                    alt={selected?.label}
                    className="gallery__preview-media"
                  />
                )}
              </div>

              <div className={`gallery__preview-label${previewVisible ? ' gallery__preview-label--visible' : ''}`}>
                <div className="gallery__preview-bar" />
                {selected?.label}
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
}

export default Gallery;
